import React, { useState } from 'react';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PropTypes from 'prop-types';
import DefaultPortrait from '../../../images/DefaultPortrait.png';

// Components
import ListCard from '../../../components/ListCard';
import BadgeStatusWidget from '../../../components/BadgeStatusWidget';
import { deviceAccent } from '../../../components/StatusChip';

// Constants
import { T, FONT_MONO } from '../../../constants/tokens';
import { locationOf } from '../../../lib/badgeTimes';

export default function StaffMemberListCard({ staffMember, onClick, selectedCardObject }) {
  const [errorLoadingImage, setErrorLoadingImage] = useState(false);

  const badge = staffMember.getBadge();
  const statusColor = deviceAccent(badge, badge?.getLastSeenRoom()?.getAlertStatus());

  // Where they last moved to, and since when. Whether the badge is still
  // being heard from is the chip beside it.
  const lastSeen = locationOf(badge) ?? 'Unknown';

  return (
    <ListCard
      statusColor={statusColor}
      onClick={onClick}
      isSelected={selectedCardObject === staffMember}
      selectedColor={statusColor}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {/* Portrait. v7 shrinks this from 120px to 40px — in a scannable list
            the name and last-seen carry the information, not the face. */}
        {errorLoadingImage ?
          <AccountCircleIcon style={{ height: 40, width: 40, flex: 'none', color: T.mutedSoft }} /> :
          <img
            height={40}
            width={40}
            src={staffMember.getImagePath() ?? DefaultPortrait}
            alt=''
            onError={() => setErrorLoadingImage(true)}
            style={{ borderRadius: 9999, objectFit: 'cover', flex: 'none' }}
          />}

        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              lineHeight: '20px',
              letterSpacing: '-0.28px',
              color: T.ink,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {staffMember.getFirstName()} {staffMember.getLastName()}
          </div>
          <div
            style={{
              fontFamily: FONT_MONO,
              fontSize: 12,
              lineHeight: '16px',
              color: T.muted,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {lastSeen}
          </div>
        </div>

        <div style={{ flex: 'none' }}>
          {badge != null ?
            <BadgeStatusWidget badge={badge} />
            :
            <span style={{ fontFamily: FONT_MONO, fontSize: 12, color: T.mutedSoft, whiteSpace: 'nowrap' }}>
              No badge
            </span>}
        </div>
      </div>
    </ListCard>
  );
}

StaffMemberListCard.propTypes = {
  staffMember: PropTypes.object,
  onClick: PropTypes.func,
  selectedCardObject: PropTypes.object
};
